<template>
  <teleport to="body">
    <transition name="fade">
      <!-- popup background -->
      <div
        v-if="isVisible"
        class="container-fluid"
      >
        <div
          class="bb-popup-bg d-flex justify-content-center align-items-center"
          :style="backdropStyle"
        >
          <!-- popup box -->
          <div
            class="card shadow bb-card mb-2 rounded"
            :style="popupStyle"
          >
            <slot></slot>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: 'PopUpModal',

  props: {
    width: {
      type: String,
      default: '24rem',
    },
    maxWidth: {
      type: String,
      default: '95vw',
    },
    minHeight: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: null,
    },
    horizontalAlign: {
      type: String,
      default: 'center',
    },
    horizontalOffset: {
      type: String,
      default: null,
    },
    zIndex: {
      type: [String, Number],
      default: 11000,
    },
  },

  data: () => ({
    isVisible: false,
  }),

  computed: {
    backdropStyle() {
      const justifyContentMap = {
        left: 'flex-start',
        center: 'center',
        right: 'flex-end',
      }

      return {
        '--bb-popup-z-index': String(this.zIndex),
        justifyContent: justifyContentMap[this.horizontalAlign] || 'center',
      }
    },
    popupStyle() {
      const sideSpacing = '1.5rem'

      return {
        width: this.width,
        maxWidth: this.maxWidth,
        minHeight: this.minHeight,
        height: this.height,
        marginLeft: this.horizontalAlign === 'left' ? sideSpacing : null,
        marginRight: this.horizontalAlign === 'right' ? sideSpacing : null,
        transform: this.horizontalOffset
          ? `translateX(${this.horizontalOffset})`
          : null,
        position: 'relative',
      }
    },
  },

  methods: {
    open() {
      this.isVisible = true
    },

    close() {
      this.isVisible = false
    },
  },
}
</script>
